import { httpClient } from "@/lib/http-client";
import { z } from "zod";

const entregadorLocationSchema = z.object({
  entregador: z.object({
    nome: z.string(),
    latitude: z.string(),
    longitude: z.string(),
    datatime: z.string(),
  }),
});

export type EntregadorLocationDto = z.infer<typeof entregadorLocationSchema>;

export class ExpressoService {
  /**
   * Obtém a localização atual do entregador
   */
  static async getDeliveryManLocation(
    userId: number,
    publicId: number
  ): Promise<EntregadorLocationDto> {
    const response = await httpClient.post<EntregadorLocationDto>(
      "/expresso/deliveryman/location",
      {
        user_id: userId,
        public_id: publicId,
      }
    );
    return entregadorLocationSchema.parse(response);
  }
}
